import { Route } from '@angular/router';

export const SEARCH_ROUTES: Route[] = [
    {
        path: '',
        loadComponent: () => import('./search.component').then((comp) => comp.SearchComponent)
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];
